module.exports = __webpack_public_path__ + "static/media/14UNEP11.c0f3b191.jpg";